import { createSlice } from '@reduxjs/toolkit';

export const boardsSlice = createSlice({
    name: "boards",
    initialState: [],
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const boardsActions = boardsSlice.actions;

export default boardsSlice.reducer;